import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Copyright from '../../components/Copyright';
import CustomTab from '../../CustomTab';

import { useApp } from '../../contexts/AppContext';

import "./styles.scss"
import Chat from '../../components/Chat';
import ContactsList from '../../components/ContactsList';
import { getInstance } from '../../services/instances';
import WelcomePage from '../../components/WelcomePage';
import { getChatByIdentity } from '../../services/chat';

// const PAGE_ICON = 'plugin';
// const BLANK = '_blank';

const Home = () => {
  const { setInstance, setPlan } = useApp()

  const { config } = useApp()

  const [customTab, setCustomTab] = useState(null)

  const [instanceRequest, setInstanceRequest] = useState("requested")

  const [resourceOpened, setResourceOpened] = useState(null)
  const [err, setErr] = useState(null)

  const { plan: planAttr } = useParams()

  const [contact, setContact] = useState()
  const [chat, setChat] = useState([])

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    startApp()
  }, [])

  useEffect(() => {
    setPlan(planAttr)
  }, [planAttr])

  useEffect(() => {
    if (contact) {
      getChat()
    }
  }, [contact])

  const getChat = async () => {
    try {
      setIsLoading(() => true)

      let { chats } = await getChatByIdentity({ identity: contact?.contact?.identity })

      setChat(chats)
    } catch (error) {
      throw error
    } finally {
      setIsLoading(() => false)
    }
  }

  const startApp = async () => {
    try {
      let instance = await getInstance()
      setInstanceRequest("found")
      setInstance(instance)
    } catch (error) {
      setErr(error)
      if (error?.response?.status === 404) {
        setInstanceRequest("notFound")
      } else {
        setInstanceRequest("error")
      }
    }
  }

  return (
    <div className="flex" style={{ height: "100vh" }}>
      <div className="home-container relative" style={{ flex: 1 }}>
        {instanceRequest === "found" &&
          <div className="inner">
            <ContactsList
              selected={contact}
              onSelect={({ contact }) => setContact(contact)}
              full={contact ? false : true}
            />

            {contact &&
              <Chat
                contact={contact.contact}
                chat={chat}
                isLoading={isLoading}
              />
            }
          </div>
        }

        {instanceRequest === "notFound" &&
          <WelcomePage onCreate={async ({ instance }) => {
            if (instance) await startApp()
          }} />
        }

        {(instanceRequest !== "found" && typeof err == "string") && (<div>{err}</div>)}

        {(!resourceOpened || (resourceOpened && config?.showCopyrightWithResourceOpen)) &&
          <Copyright />
        }
      </div>

      <CustomTab
        opened={customTab != null}
        setCustomTab={setCustomTab}
        {...customTab}
      />
    </div>
  );
};

Home.propTypes = {};

export default Home;
